import { useRef } from 'react';
import clsx from 'clsx';
import { v4 as uuid } from 'uuid';
import { Col, Row, Container } from '@ag1/ui';
import { SanityKeyed, TagsLineV2 as TagsLineV2Props } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import useAddAccessibility from 'shared/hooks/addAccessibility';
import Tag from './Tag/Tag';
import TagCustom from './TagCustom/TagCustom';
import styles from './TagsLineV2.module.scss';
import { CommonSectionProps } from '../types';

const TagsLineV2 = ({
  iconSelect,
  alignIconsToLeft,
  tags,
  tagsCustom,
  bgColor,
  padding,
  theme,
  _key: key
}: SanityKeyed<TagsLineV2Props> & CommonSectionProps) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useAddAccessibility(contentRef, true);

  return (
    <>
      {iconSelect === 'checkmarks' && tags && (
        <ul
          id={key}
          className={clsx(
            styles.list,
            iconSelect === 'checkmarks' ? styles.line : styles.columns,
            bgColor === 'white' && styles.white,
            bgColor === 'grey' && styles.grey,
            getThemeCSSClass(theme)
          )}>
          {tags.map((tag) => (
            <Tag key={uuid()} text={tag} bgColor={bgColor} theme={theme} />
          ))}
        </ul>
      )}
      {iconSelect === 'custom' && tagsCustom && (
        <div
          ref={contentRef}
          className={clsx(
            styles.rootCustom,
            bgColor === 'white' && styles.white,
            bgColor === 'grey' && styles.grey,
            getThemeCSSClass(theme),
            getSectionPaddingClasses(styles, padding)
          )}>
          <Container narrow>
            <Row className={styles.listCustom}>
              {tagsCustom?.map(
                (tag) =>
                  tag &&
                  tag.text && (
                    <Col
                      key={uuid()}
                      span={{ xxs: 12, s: 6, l: 4 }}
                      className={clsx(alignIconsToLeft ? styles.alignLeft : styles.alignCenter)}>
                      <TagCustom icon={tag.icon} text={tag.text} bgColor={bgColor} theme={theme} />
                    </Col>
                  )
              )}
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default TagsLineV2;
